import React, { useEffect, useState } from "react";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import dummyProfileImg from "../../assets/committeeProfileImg.png";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Dialog,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./profiles.scss";
import picGuildLines from "../../assets/photoGuildLines.png";
import axios from "axios";
import {
  API_URL,
  charanValues,
  complexionValues,
  ganValues,
  maritial_statusValues,
  nadiValues,
  nakshatraValues,
  rashiValues,
  siblingsCount,
} from "../../variables";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DialogBox from "../shared/dialog/dialogBox";
import { convertBirthTime } from "../../sharedFunctions";
//import UserProfilesTab from "./userProfilesTab";
import ProfilesTaken from "./profilesTaken";
import ProfileViewed from "./profileViewed";
import ImageCarousel from "../shared/imageCarousel/imageCarousel";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const MyProfile = () => {
  const theme = useTheme();
  let navigate = useNavigate();
  const [loggedInUserInfo, setLoggedInUserInfo] = useState([]);
  const [showActivatePopup, setshowActivatePopup] = useState(true);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  var specialCharecters = /[`!@#$%^&*()_+\-=\[\]{};':"\\|<>\/?~]/;
  var addressCheck = /[`!@#$%^&*+=\[\]{};"\\|<>?~]/;
  const [value, setValue] = useState(
    localStorage.getItem("image_uploaded") === "yes" ? 0 : 3
  );
  const [files, setFiles] = useState({
    image1_id: null,
    image2_id: null,
  });
  const [mode, setMode] = useState("read");
  const handleChange = (Event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      localStorage.getItem("member_id") === undefined ||
      localStorage.getItem("member_id") === null
    ) {
      navigate("/login");
    }
    if (localStorage.getItem("image_uploaded") === "yes") {
      getLoggedInUserDetails();
    }
  }, []);

  const getLoggedInUserDetails = async () => {
    if (localStorage.getItem("member_status") === "active") {
      let res = await axios.post(
        API_URL + "my_profile?member_id=" + localStorage.getItem("member_id")
      );
      if (res.data.statusCode === 200) {
        setLoggedInUserInfo(res.data.body[0]);
      }
    }
    if (
      localStorage.getItem("image_uploaded") === "yes" &&
      localStorage.getItem("member_status") === "deactive"
    ) {
      setShowContactPopup(true);
    }
  };

  const uploadPhotos = async (e) => {
    e.preventDefault();
    const formDataObj = new FormData();
    formDataObj.append("image1", files.image1_id);
    formDataObj.append("image2", files.image2_id);
    formDataObj.append("member_id", localStorage.getItem("member_id"));
    const response = await axios.post(
      API_URL + "upload_image/" + localStorage.getItem("member_id"),
      formDataObj,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.data.statusCode === 200) {
      toast.success("Photos uploaded successfully.", {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      if (
        localStorage.getItem("image_uploaded") === "no" &&
        localStorage.getItem("member_status") === "deactive"
      ) {
        setShowContactPopup(true);
      }
    }
  };

  const updateUserDetails = async () => {
    delete loggedInUserInfo["images"];
    await axios
      .put(
        API_URL +
          "editmember?member_id=" +
          localStorage.getItem("member_id") +
          "&data=" +
          JSON.stringify(loggedInUserInfo)
      )
      .then(function (res) {
        toast.success("Details updated successfully.", {
          position: "top-center",
          autoClose: 8000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        getLoggedInUserDetails();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const hideConfirmation = (value) => {
    setShowConfirmation(false);
  };

  const getDOB = (value) => {
    let temp =
      value.split("-")[2] +
      "-" +
      value.split("-")[1] +
      "-" +
      value.split("-")[0];
    return temp;
  };

  const getBirthTime = (val1, val2) => {
    return getDOB(val1) + "T" + val2;
  };

  const confirmRequest = async (value) => {
    if (value) {
      await axios
        .post(
          API_URL +
            "request_profile_delete?member_id=" +
            localStorage.getItem("member_id")
        )
        .then(function (res) {
          if (res.status === 200) {
            toast.success("Profile deleted successfully.", {
              position: "top-center",
              autoClose: 8000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            localStorage.clear();
            navigate("/");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <section className="p-4 formSection bg-white mt-4">
        <label className="headerLabel pl-3 mb-3">My Profile</label>
        <label className="d-block textDarkRed font-bold pl-3">
          Profiles for which you can get contacts :{" "}
          {loggedInUserInfo?.subscription?.subs_remaining_count}
        </label>
        <label className="d-block textDarkRed font-bold pl-3">
          Total number of get contacts as per your subscription :{" "}
          {loggedInUserInfo?.subscription?.subs_total_count}
        </label>
        <Box sx={{ bgcolor: "background.paper" }} className="tabsWrapper">
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              className="profileTabs"
            >
              <Tab label="My Profile" {...a11yProps(0)} />
              <Tab label="Profiles Taken" {...a11yProps(1)} />
              <Tab label="Profile Viewed" {...a11yProps(2)} />
              <Tab label="My Photos" {...a11yProps(3)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0} dir={theme.direction}>
            {localStorage.getItem("image_uploaded") === "yes" && (
              <section className="formSection bg-white mt-4 maxWidth100">
                <div className="row">
                  <div className="d-flex flex-row phoneView">
                    {mode === "read" && (
                      <Button
                        size="small"
                        variant="contained"
                        className="transparentBtnClass mr-3 editBtn font12px"
                        onClick={() => {
                          setMode("edit");
                        }}
                      >
                        <EditIcon className="mr-1" />
                        Edit Profile
                      </Button>
                    )}
                    {mode === "edit" && (
                      <Button
                        size="small"
                        variant="contained"
                        className="transparentBtnClass mr-3 deleteBtn font12px"
                        onClick={() => {
                          setMode("read");
                          updateUserDetails();
                        }}
                      >
                        <SaveIcon className="mr-1" />
                        Save Deatils
                      </Button>
                    )}
                    <Button
                      size="small"
                      variant="contained"
                      className="transparentBtnClass font12px deleteBtn"
                      onClick={() => {
                        setShowConfirmation(true);
                      }}
                    >
                      <DeleteIcon className="mr-1" />
                      Delete Profile
                    </Button>
                  </div>
                  <div className="col-md-9 accordianDetails p-3">
                    <div className="row p-2">
                      <div className="col-md-2 p-1">
                        {loggedInUserInfo?.images?.length > 0 ? (
                          <ImageCarousel
                            carouselData={loggedInUserInfo?.images}
                          />
                        ) : (
                          <img
                            src={dummyProfileImg}
                            alt=""
                            className="profileImg"
                          />
                        )}
                      </div>
                      <div className="col-md-10 profileData p-1">
                        <div className="text-right desktopView">
                          {mode === "read" && (
                            <Button
                              size="large"
                              variant="contained"
                              className="transparentBtnClass mr-3 editBtn"
                              onClick={() => {
                                setMode("edit");
                              }}
                            >
                              <EditIcon className="mr-2" />
                              Edit Profile
                            </Button>
                          )}
                          {mode === "edit" && (
                            <Button
                              size="large"
                              variant="contained"
                              className="transparentBtnClass mr-3 deleteBtn"
                              onClick={() => {
                                setMode("read");
                                setLoggedInUserInfo((prev) => ({
                                  ...prev,
                                  member_id:
                                    loggedInUserInfo?.member_id.toUpperCase(),
                                }));
                                updateUserDetails();
                              }}
                            >
                              <SaveIcon className="mr-2" />
                              Save Details
                            </Button>
                          )}
                          <Button
                            size="large"
                            variant="contained"
                            className="transparentBtnClass"
                            onClick={() => {
                              setShowConfirmation(true);
                            }}
                          >
                            <DeleteIcon className="mr-3" />
                            Delete Profile Request
                          </Button>
                        </div>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              PERSONAL DETAILS / वैयक्तिक माहिती
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>First Name / पहिले नाव</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.first_name}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.first_name}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          first_name: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Middle Name / मधले नाव</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.middle_name}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.middle_name}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          middle_name: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Last Name / आडनाव</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.last_name}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.last_name}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          last_name: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Height / उंची (ft: inch)</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.heightFt}'
                                    {loggedInUserInfo?.heightInch}"
                                  </label>
                                ) : (
                                  <div className="d-flex">
                                    <Select
                                      className="w-50 d-inline-block mr-1 dropdownPadding"
                                      value={loggedInUserInfo?.heightFt}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          heightFt: event.target.value,
                                        }));
                                      }}
                                    >
                                      <MenuItem value="none">Select</MenuItem>
                                      <MenuItem value="4">4</MenuItem>
                                      <MenuItem value="5">5</MenuItem>
                                      <MenuItem value="6">6</MenuItem>
                                      <MenuItem value="7">7</MenuItem>
                                      <MenuItem value="8">8</MenuItem>
                                    </Select>
                                    <Select
                                      className="w-50 d-inline-block ml-1 dropdownPadding"
                                      value={loggedInUserInfo?.heightInch}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          heightInch: event.target.value,
                                        }));
                                      }}
                                    >
                                      <MenuItem value="Unspecified">
                                        Select
                                      </MenuItem>
                                      <MenuItem value="0">0</MenuItem>
                                      <MenuItem value="1">1</MenuItem>
                                      <MenuItem value="2">2</MenuItem>
                                      <MenuItem value="3">3</MenuItem>
                                      <MenuItem value="4">4</MenuItem>
                                      <MenuItem value="5">5</MenuItem>
                                      <MenuItem value="6">6</MenuItem>
                                      <MenuItem value="7">7</MenuItem>
                                      <MenuItem value="8">8</MenuItem>
                                      <MenuItem value="9">9</MenuItem>
                                      <MenuItem value="10">10</MenuItem>
                                      <MenuItem value="11">11</MenuItem>
                                      <MenuItem value="12">12</MenuItem>
                                    </Select>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Blood Group / रक्त गट</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.blood_group}
                                  </label>
                                ) : (
                                  <Select
                                    className="dropdownPadding w-100"
                                    value={loggedInUserInfo?.blood_group}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        blood_group: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    <MenuItem value="a+">A+</MenuItem>
                                    <MenuItem value="a-">A-</MenuItem>
                                    <MenuItem value="b+">B+</MenuItem>
                                    <MenuItem value="b-">B-</MenuItem>
                                    <MenuItem value="ab+">AB+</MenuItem>
                                    <MenuItem value="ab-">AB-</MenuItem>
                                    <MenuItem value="o+">O+</MenuItem>
                                    <MenuItem value="o-">O-</MenuItem>
                                    <MenuItem value="--">Don't Know</MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Spectacles / चष्मा</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.spectacles}
                                  </label>
                                ) : (
                                  <RadioGroup
                                    name="Spectacles"
                                    row
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        spectacles: event.target.value,
                                      }));
                                    }}
                                    value={loggedInUserInfo?.spectacles}
                                  >
                                    <FormControlLabel
                                      value="yes"
                                      control={<Radio />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="no"
                                      control={<Radio />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                )}
                              </div>
                              <div className="col">
                                <label>Weight / वजन(KG)</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.weight}
                                  </label>
                                ) : (
                                  <TextField
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.weight}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        weight: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Maritial Status / वैवाहिक स्थिती /
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.maritial_status}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize dropdownPadding w-100"
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        maritial_status: event.target.value,
                                      }));
                                    }}
                                    value={loggedInUserInfo?.maritial_status}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {maritial_statusValues.map(
                                      (item, index) => {
                                        return (
                                          <MenuItem
                                            value={item}
                                            key={index}
                                            className="text-capitalize"
                                          >
                                            {item}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </Select>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Gender / लिंग</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.gender}
                                  </label>
                                ) : (
                                  <RadioGroup
                                    name="Gender"
                                    row
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        gender: event.target.value,
                                      }));
                                    }}
                                    value={loggedInUserInfo?.gender}
                                  >
                                    <FormControlLabel
                                      value="male"
                                      control={<Radio />}
                                      label="Male"
                                    />
                                    <FormControlLabel
                                      value="female"
                                      control={<Radio />}
                                      label="Female"
                                    />
                                  </RadioGroup>
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Physical disability / शारीरिक अपंगत्व
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.physical_disability}
                                  </label>
                                ) : (
                                  <RadioGroup
                                    name="Disability"
                                    row
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        physical_disability: event.target.value,
                                      }));
                                    }}
                                    value={
                                      loggedInUserInfo?.physical_disability
                                    }
                                  >
                                    <FormControlLabel
                                      value="yes"
                                      control={<Radio />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="no"
                                      control={<Radio />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                )}
                              </div>
                              <div className="col">
                                <label>Complexion / रंग </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.complexion}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.complexion}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        complexion: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {complexionValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Mother Tongue / मातृभाषा</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.mother_tongue}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.mother_tongue}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        mother_tongue: event.target.value,
                                      }));
                                    }}
                                  >
                                    <span className="pl-3 font-bold">
                                      Official Languages
                                    </span>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"hindi"}
                                    >
                                      Hindi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"english"}
                                    >
                                      English
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"other"}
                                    >
                                      Other
                                    </MenuItem>
                                    <span className="pl-3 font-bold">
                                      Major Languages
                                    </span>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"bengali"}
                                    >
                                      Bengali
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"telugu"}
                                    >
                                      Telugu
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"marathi"}
                                    >
                                      Marathi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"tamil"}
                                    >
                                      Tamil
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"gujarati"}
                                    >
                                      Gujarati
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"malayalam"}
                                    >
                                      Malayalam
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"kannada"}
                                    >
                                      Kannada
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"odia"}
                                    >
                                      Odia
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"punjabi"}
                                    >
                                      Punjabi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"assamese"}
                                    >
                                      Assamese
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"maithili"}
                                    >
                                      Maithili
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"santhali"}
                                    >
                                      Santhali
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"kashmiri"}
                                    >
                                      Kashmiri
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"nepali"}
                                    >
                                      Nepali
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"konkani"}
                                    >
                                      Konkani
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"manipuri"}
                                    >
                                      Manipuri
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"dogri"}
                                    >
                                      Dogri
                                    </MenuItem>
                                    <span className="pl-3 font-bold">
                                      Regional Languages and Dialects
                                    </span>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"bodo"}
                                    >
                                      Bodo
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"khasi"}
                                    >
                                      Khasi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"sindhi"}
                                    >
                                      Sindhi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"urdu"}
                                    >
                                      Urdu
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"rajasthani"}
                                    >
                                      Rajasthani
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"magahi"}
                                    >
                                      Magahi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"bhojpuri"}
                                    >
                                      Bhojpuri
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"chhattisgarhi"}
                                    >
                                      Chhattisgarhi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"haryanvi"}
                                    >
                                      Haryanvi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"awadhi"}
                                    >
                                      Awadhi
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"garhwali"}
                                    >
                                      Garhwali
                                    </MenuItem>
                                    <MenuItem
                                      className="text-capitalize"
                                      value={"himachali"}
                                    >
                                      Himachali
                                    </MenuItem>
                                  </Select>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Diet / आहार</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.diet}
                                  </label>
                                ) : (
                                  <RadioGroup
                                    name="Diet"
                                    row
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        diet: event.target.value,
                                      }));
                                    }}
                                    value={loggedInUserInfo?.diet}
                                  >
                                    <FormControlLabel
                                      value="veg"
                                      control={<Radio />}
                                      label="Veg"
                                    />
                                    <FormControlLabel
                                      value="non veg"
                                      control={<Radio />}
                                      label="Non Veg"
                                    />
                                    <FormControlLabel
                                      value="both"
                                      control={<Radio />}
                                      label="Both"
                                    />
                                  </RadioGroup>
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              HOROSCOPE DETAILS / कुंडली तपशील
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>Rashi / राशी</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.rashi}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.rashi}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        rashi: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {rashiValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Nakshatra / नक्षत्र</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.nakshatra}
                                  </label>
                                ) : (
                                  <Select
                                    value={loggedInUserInfo?.nakshatra}
                                    className="text-capitalize w-100 dropdownPadding"
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        nakshatra: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {nakshatraValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Charan / चरण</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.charan}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.charan}
                                    onChange={(event) => {
                                      loggedInUserInfo((prev) => ({
                                        ...prev,
                                        charan: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {charanValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Nadi / नाडी</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.nadi}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.nadi}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        nadi: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {nadiValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Gan / गण</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.gan}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.gan}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        gan: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {ganValues.map((item, index) => {
                                      return (
                                        <MenuItem
                                          value={item}
                                          key={index}
                                          className="text-capitalize"
                                        >
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Date of birth / जन्मतारीख</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.dob}
                                  </label>
                                ) : (
                                  // <label className="textDarkRed font-bold text-capitalize">
                                  //   {loggedInUserInfo?.dob}
                                  // </label>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DemoContainer components={["DatePicker"]}>
                                      <DatePicker
                                        className="datepickerPadding"
                                        defaultValue={dayjs(
                                          getDOB(loggedInUserInfo?.dob)
                                        )}
                                        onChange={(event) => {
                                          var date = new Date(event.$d),
                                            mnth = (
                                              "0" +
                                              (date.getMonth() + 1)
                                            ).slice(-2),
                                            day = ("0" + date.getDate()).slice(
                                              -2
                                            );
                                          let dateOfBirth = [
                                            day,
                                            mnth,
                                            date.getFullYear(),
                                          ].join("-");
                                          setLoggedInUserInfo((prev) => ({
                                            ...prev,
                                            dob: dateOfBirth,
                                          }));
                                        }}
                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                )}
                              </div>
                              <div className="col">
                                <label>Birthplace / जन्मस्थान</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.birthplace}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.birthplace}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        birthplace: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Birth Time / जन्मवेळ*</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {convertBirthTime(
                                      loggedInUserInfo?.birth_time
                                    )}
                                  </label>
                                ) : (
                                  // <label className="textDarkRed font-bold text-capitalize">
                                  //   {convertBirthTime(
                                  //     loggedInUserInfo?.birth_time
                                  //   )}
                                  // </label>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DemoContainer components={["TimePicker"]}>
                                      <TimePicker
                                        className="datepickerPadding"
                                        defaultValue={dayjs(
                                          getBirthTime(
                                            loggedInUserInfo?.dob,
                                            loggedInUserInfo?.birth_time
                                          )
                                        )}
                                        onChange={(event) => {
                                          let time = event.$H + ":" + event.$m;
                                          setLoggedInUserInfo((prev) => ({
                                            ...prev,
                                            birth_time: time,
                                          }));
                                        }}
                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              Educational / Professional Details / शैक्षणिक /
                              व्यावसायिक तपशील:
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>Education Area / शिक्षण क्षेत्र</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.education_area}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize w-100 dropdownPadding"
                                    value={loggedInUserInfo?.education_area}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        education_area: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    <MenuItem value="12th">10th</MenuItem>
                                    <MenuItem value="12th">12th</MenuItem>
                                    <MenuItem value="diploma">Diploma</MenuItem>
                                    <MenuItem value="graduate">
                                      Graduate
                                    </MenuItem>
                                    <MenuItem value="post graduate">
                                      Post - Graduate
                                    </MenuItem>
                                    <MenuItem value="doctor">Doctor</MenuItem>
                                    <MenuItem value="engineer">
                                      Engineer / PG Engg
                                    </MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Education / शिक्षण</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.education}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.education}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        education: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Occupation / व्यवसाय</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.occupation}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.occupation}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        occupation: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Income / उत्पन्न</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold">
                                    {loggedInUserInfo?.income_amt}{" "}
                                    {loggedInUserInfo?.income_type}
                                  </label>
                                ) : (
                                  <div>
                                    <TextField
                                      type="number"
                                      className="w-50 d-inline-block"
                                      size="small"
                                      variant="outlined"
                                      value={loggedInUserInfo?.income_amt}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          income_amt: event.target.value,
                                          income:
                                            event.target.value.length > 0
                                              ? event.target.value +
                                                " " +
                                                loggedInUserInfo?.income_type
                                              : "",
                                        }));
                                      }}
                                    />
                                    <Select
                                      className="w-25 d-inline-block ml-2 dropdownPadding"
                                      value={loggedInUserInfo?.income_type}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          income_type: event.target.value,
                                          income:
                                            loggedInUserInfo?.income_amt
                                              .length > 0
                                              ? loggedInUserInfo?.income_amt +
                                                " " +
                                                event.target.value
                                              : "",
                                        }));
                                      }}
                                    >
                                      <MenuItem value="pa">PA</MenuItem>
                                      <MenuItem value="pm">PM</MenuItem>
                                    </Select>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Country / व्यवसाय देश</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.country}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.country}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          country: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>State / राज्य</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.state}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.state}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          state: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>City / शहर</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.city}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.city}
                                    onChange={(event) => {
                                      if (
                                        !specialCharecters.test(
                                          event.target.value
                                        )
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          city: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>&nbsp;</label>
                                <label className="textDarkRed"></label>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              Address / पत्ता
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>Aadhar Number :</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.adhar}
                                  </label>
                                ) : (
                                  <TextField
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.adhar}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        adhar: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Primary contact number / प्राथमिक संपर्क
                                  क्रमांक
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.mobile_no}
                                  </label>
                                ) : (
                                  <TextField
                                    type="number"
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.mobile_no}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        mobile_no: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Secondary contact number / दुय्यम संपर्क
                                  क्रमांक
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.sec_mobile}
                                  </label>
                                ) : (
                                  <TextField
                                    type="number"
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.sec_mobile}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        sec_mobile: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-8">
                                <label>
                                  Residence Address / निवासाचा पत्ता/
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.address}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.address}
                                    onChange={(event) => {
                                      if (
                                        !addressCheck.test(event.target.value)
                                      )
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          address: event.target.value,
                                        }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col-md-4">
                                <label>
                                  *E-mail ID (Its important) / *ई-मेल आयडी
                                  (त्याचा महत्त्वाचा):
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold">
                                    {loggedInUserInfo?.email}
                                  </label>
                                ) : (
                                  <TextField
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.email}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        email: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              Family Background / कौटुंबिक पार्श्वभूमी
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>Father / वडील</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.father}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.father}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        father: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value={"yes"}>Yes</MenuItem>
                                    <MenuItem value={"no"}>No</MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Mother / आई</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.mother}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.mother}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        mother: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value={"yes"}>Yes</MenuItem>
                                    <MenuItem value={"no"}>No</MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Brothers / भाऊ</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.brother}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.brother}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        brother: event.target.value,
                                      }));
                                    }}
                                  >
                                    {siblingsCount?.map((item, index) => {
                                      return (
                                        <MenuItem value={item} key={index}>
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Married Brothers / विवाहित भाऊ </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.married_brother}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.married_brother}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        married_brother: event.target.value,
                                      }));
                                    }}
                                  >
                                    {siblingsCount?.map((item, index) => {
                                      return (
                                        <MenuItem value={item} key={index}>
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>Sisters / बहिणी</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.sister}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.sister}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        sister: event.target.value,
                                      }));
                                    }}
                                  >
                                    {siblingsCount?.map((item, index) => {
                                      return (
                                        <MenuItem value={item} key={index}>
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  <span class="extraInfo-1Y8HL">
                                    Married Sisters / विवाहित बहिणी
                                  </span>
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.married_sister}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.married_sister}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        married_sister: event.target.value,
                                      }));
                                    }}
                                  >
                                    {siblingsCount?.map((item, index) => {
                                      return (
                                        <MenuItem value={item} key={index}>
                                          {item}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  <span class="extraInfo-1Y8HL">
                                    Parents Fullname / पालकांचे पूर्ण नाव:
                                  </span>
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.parents_full_name}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.parents_full_name}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        parents_full_name: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Parents Occupation / पालकांचा व्यवसाय
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.parents_occupation}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.parents_occupation}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        parents_occupation: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>
                                  Parents Resident City / पालक निवासी शहर
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.parents_resident_city}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={
                                      loggedInUserInfo?.parents_resident_city
                                    }
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        parents_resident_city:
                                          event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  *Native District (Its important) / *मूळ जिल्हा
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.native_district}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.native_district}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        native_district: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Native Taluka, If Any / मूळ तालुका
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.native_taluka}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.native_taluka}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        native_taluka: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>
                                  Surnames of Relatives / नातेवाईकांची आडनावे
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.relatives_surnames}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.relatives_surnames}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        relatives_surnames: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  Mama’s Surname / Place / आईचे आडनाव / ठिकाण
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.mama_surname}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.mama_surname}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        mama_surname: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>
                                  Any Intercast Marriage in Core Family / मूळ
                                  कुटुंबात कोणताही आंतरजातीय विवाह :
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.intercast_marriage}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.intercast_marriage}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        intercast_marriage: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value={"yes"}>Yes</MenuItem>
                                    <MenuItem value={"no"}>No</MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>
                                  If yes (Relation/Caste) / जर होय (नाते/जात):
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.caste}
                                  </label>
                                ) : (
                                  <TextField
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.caste}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        caste: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="accordianHeader"
                          >
                            <Typography className="textDarkRed">
                              Expectation / अपेक्षा
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="accordianDetails profileDetails">
                            <div className="row">
                              <div className="col">
                                <label>Preferred Cities / पसंतीची शहरे</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.preffered_cities}
                                  </label>
                                ) : (
                                  <TextField
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.preffered_cities}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        preffered_cities: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Mangal / मंगल</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_mangal}
                                  </label>
                                ) : (
                                  <Select
                                    className="w-100 dropdownPadding"
                                    value={loggedInUserInfo?.exp_mangal}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        exp_mangal: event.target.value,
                                      }));
                                    }}
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    <MenuItem value="yes">Yes</MenuItem>
                                    <MenuItem value="no">No</MenuItem>
                                    <MenuItem value="saumya">Saumya</MenuItem>
                                    <MenuItem value="nirdosh">Nirdosh</MenuItem>
                                    <MenuItem value="not known">
                                      Not Known
                                    </MenuItem>
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Height / उंची (ft: inch)</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_heightFt}'
                                    {loggedInUserInfo?.exp_heightInch}"
                                  </label>
                                ) : (
                                  <div className="d-flex heightDropdowns">
                                    <Select
                                      className="w-50 d-inline-block mr-1 dropdownPadding"
                                      value={loggedInUserInfo?.exp_heightFt}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          exp_heightFt: event.target.value,
                                        }));
                                      }}
                                    >
                                      <MenuItem value="Unspecified">
                                        Feet
                                      </MenuItem>
                                      <MenuItem value="4">4</MenuItem>
                                      <MenuItem value="5">5</MenuItem>
                                      <MenuItem value="6">6</MenuItem>
                                      <MenuItem value="7">7</MenuItem>
                                      <MenuItem value="8">8</MenuItem>
                                    </Select>
                                    <Select
                                      className="w-50 d-inline-block ml-1 dropdownPadding"
                                      value={loggedInUserInfo?.exp_heightInch}
                                      onChange={(event) => {
                                        setLoggedInUserInfo((prev) => ({
                                          ...prev,
                                          Inch: event.target.value,
                                        }));
                                      }}
                                    >
                                      <MenuItem value="Unspecified">
                                        Inches
                                      </MenuItem>
                                      <MenuItem value="0">0</MenuItem>
                                      <MenuItem value="1">1</MenuItem>
                                      <MenuItem value="2">2</MenuItem>
                                      <MenuItem value="3">3</MenuItem>
                                      <MenuItem value="4">4</MenuItem>
                                      <MenuItem value="5">5</MenuItem>
                                      <MenuItem value="6">6</MenuItem>
                                      <MenuItem value="7">7</MenuItem>
                                      <MenuItem value="8">8</MenuItem>
                                      <MenuItem value="9">9</MenuItem>
                                      <MenuItem value="10">10</MenuItem>
                                      <MenuItem value="11">11</MenuItem>
                                      <MenuItem value="12">12</MenuItem>
                                    </Select>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <label>
                                  Expected Education / अपेक्षित शिक्षण{" "}
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_education}
                                  </label>
                                ) : (
                                  <TextField
                                    className="text-capitalize"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.exp_education}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        exp_education: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                              <div className="col">
                                <label>Maritial Status / वैवाहिक स्थिती </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_maritial_status}
                                  </label>
                                ) : (
                                  <Select
                                    className="text-capitalize dropdownPadding w-100"
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        exp_maritial_status: event.target.value,
                                      }));
                                    }}
                                    value={
                                      loggedInUserInfo?.exp_maritial_status
                                    }
                                  >
                                    <MenuItem value="Unspecified">
                                      Select
                                    </MenuItem>
                                    {maritial_statusValues.map(
                                      (item, index) => {
                                        return (
                                          <MenuItem
                                            value={item}
                                            key={index}
                                            className="text-capitalize"
                                          >
                                            {item}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                  </Select>
                                )}
                              </div>
                              <div className="col">
                                <label>Max Age Difference / कमाल वय फरक</label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_age_diff}
                                  </label>
                                ) : (
                                  <TextField
                                    type="number"
                                    size="small"
                                    variant="outlined"
                                    value={loggedInUserInfo?.exp_age_diff}
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        exp_age_diff: event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12 col-sm-12">
                                <label>
                                  Expected Occupation & Income per Annum /
                                  अपेक्षित व्यवसाय आणि वार्षिक उत्पन्न{" "}
                                </label>
                                {mode === "read" ? (
                                  <label className="textDarkRed font-bold text-capitalize">
                                    {loggedInUserInfo?.exp_occupation_income}
                                  </label>
                                ) : (
                                  <TextField
                                    className="w-100"
                                    size="small"
                                    variant="outlined"
                                    value={
                                      loggedInUserInfo?.exp_occupation_income
                                    }
                                    onChange={(event) => {
                                      setLoggedInUserInfo((prev) => ({
                                        ...prev,
                                        exp_occupation_income:
                                          event.target.value,
                                      }));
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                        <label className="d-block mt-3 pl-3 mb-0">
                          Committee Member / समिती सदस्य
                        </label>
                        <label className="textDarkRed font-bold text-capitalize pl-3">
                          {loggedInUserInfo?.committee_member}
                        </label>
                        <label className="d-block mt-1 pl-3">
                          KSJ Family ID
                        </label>
                        <label className="textDarkRed font-bold text-capitalize pl-3">
                          {loggedInUserInfo?.ksj_family_id}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 p-3">
                    <label className="textDarkRed">
                      For more information kindly go through the below videos or
                      contact us
                    </label>
                    <div className="p-2 mb-3">
                      <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                        <PlayCircleIcon className="playIcon" />
                      </div>
                      <label className="textDarkRed font18px font-bold">
                        How to login
                      </label>
                    </div>
                    <div className="p-2 mb-3">
                      <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                        <PlayCircleIcon className="playIcon" />
                      </div>
                      <label className="textDarkRed font18px font-bold">
                        How to register yourself
                      </label>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            {localStorage.getItem("image_uploaded") === "yes" && (
              <ProfilesTaken />
            )}
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            {localStorage.getItem("image_uploaded") === "yes" && (
              <ProfileViewed />
            )}
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <section className=" bg-white ">
              <div className="row">
                <div className="col-md-9 accordianDetails p-3">
                  <form onSubmit={uploadPhotos}>
                    <label className="textDarkRed font22px">
                      Upload Photo and get better Matches
                    </label>
                    <div className="row">
                      <div className="col phoneFullWIdth">
                        <div className="d-inline-block w-50 phoneFullWIdth">
                          <label className="textDarkRed d-block">
                            Photo Close Up
                          </label>
                          <img src={picGuildLines} alt="" />
                          {/* <Button
                          size="large"
                          variant="contained"
                          className="buttonClass"
                        >
                          Click to Upload
                        </Button> */}
                          <input
                            type="file"
                            name="image1_id"
                            accept="image/*"
                            onChange={(event) => {
                              const file = event.target.files[0];
                              if (file && file.size > 50 * 1024 * 1024) {
                                alert(
                                  "File size exceeds 50 MB limit. Please upload a smaller file."
                                );
                                return;
                              }
                              setFiles((prev) => ({
                                ...prev,
                                image1_id: file,
                              }));
                            }}
                            required
                          />
                        </div>
                        <div className="d-inline-block w-50 phoneFullWIdth">
                          <label className="textDarkRed d-block">
                            Photo Full View
                          </label>
                          <img src={picGuildLines} alt="" />
                          {/* <Button
                          size="large"
                          variant="contained"
                          className="buttonClass"
                        >
                          Click to Upload
                        </Button> */}
                          <input
                            type="file"
                            name="image2_id"
                            accept="image/*"
                            onChange={(event) => {
                              const file = event.target.files[0];
                              if (file && file.size > 50 * 1024 * 1024) {
                                alert(
                                  "File size exceeds 50 MB limit. Please upload a smaller file."
                                );
                                return;
                              }
                              setFiles((prev) => ({
                                ...prev,
                                image2_id: file,
                              }));
                            }}
                            required
                          />
                        </div>
                        <Button
                          type="submit"
                          size="large"
                          variant="contained"
                          className="buttonClass mt-3"
                        >
                          Submit Photos
                        </Button>
                      </div>
                      <div className="col phoneFullWIdth">
                        <div className="d-inline-block">
                          <label className="textDarkRed d-block">
                            Photo Guidelines
                          </label>
                          <img src={picGuildLines} alt="" />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="textDarkRed font22px">Know More</label>
                      <div className="row">
                        <div className="col phoneFullWIdth">
                          <label className="textDarkRed font18px">Do's</label>
                          <ul className="pl-3">
                            <li>
                              Your Photo should be front facing and your entire
                              face should be visible.
                            </li>
                            <li>
                              Ensure that your Photo is recent and not with a
                              group.
                            </li>
                            <li>
                              You can upload upto 2 Photos to your Profile.
                            </li>
                            <li>
                              Each Photo must be less than 15 MB in size and
                              must be in one of the following formats jpg, png
                            </li>
                          </ul>
                        </div>
                        <div className="col phoneFullWIdth">
                          <label className="textDarkRed font18px">Dont's</label>
                          <ul className="pl-3">
                            <li>
                              Watermarked, digitally enhanced, morphed Photos or
                              Photos with your personal information will be
                              rejected.
                            </li>
                            <li>
                              Irrelevant Photographs will lead to deactivation
                              of your Profile and Membership.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-md-3 p-3">
                  <label className="textDarkRed">
                    For more information kindly go through the below videos or
                    contact us
                  </label>
                  <div className="p-2 mb-3">
                    <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                      <PlayCircleIcon className="playIcon" />
                    </div>
                    <label className="textDarkRed font18px font-bold">
                      How to login
                    </label>
                  </div>
                  <div className="p-2 mb-3">
                    <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                      <PlayCircleIcon className="playIcon" />
                    </div>
                    <label className="textDarkRed font18px font-bold">
                      How to register yourself
                    </label>
                  </div>
                </div>
              </div>
            </section>
          </TabPanel>
        </Box>
      </section>
      <FooterComponent />
      {showContactPopup && (
        <Dialog open={showActivatePopup}>
          <section className="p-3">
            Please contact Kumbhar Mangalam to activate your profile.
            <div className="text-center">
              <Button
                size="large"
                variant="contained"
                className="buttonClass mt-3"
                onClick={() => {
                  setshowActivatePopup(false);
                  localStorage.clear();
                  navigate("/");
                }}
              >
                Logout
              </Button>
            </div>
          </section>
        </Dialog>
      )}
      <DialogBox
        open={showConfirmation}
        content="Do you really want to delete your profile?"
        heading="Confirmation"
        button1="Confirm"
        button2="Cancel"
        confirmRequest={confirmRequest}
        hideConfirmation={hideConfirmation}
      />
    </>
  );
};

export default MyProfile;
